export default __webpack_public_path__ + "static/ifc-desktop-b278ee6d2d345d9bdc88e5a069c87920.png";